import { render, staticRenderFns } from "./KetersediaanTempatTidur.vue?vue&type=template&id=15a8c781"
import script from "./KetersediaanTempatTidur.vue?vue&type=script&lang=js"
export * from "./KetersediaanTempatTidur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a8c781')) {
      api.createRecord('15a8c781', component.options)
    } else {
      api.reload('15a8c781', component.options)
    }
    module.hot.accept("./KetersediaanTempatTidur.vue?vue&type=template&id=15a8c781", function () {
      api.rerender('15a8c781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/identitas-rumah-sakit/KetersediaanTempatTidur.vue"
export default component.exports